import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { SlidesList } from './SlidesList'
import 'normalize.css'

ReactDOM.render(<SlidesList />, document.getElementById('app'))
